export default "__VITE_ASSET__DcQUhx_4__"